import React from 'react'

import { ApolloProvider } from '@apollo/client'

import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'

export const RestaurantProfilePageContexts = ({
  children
}: React.PropsWithChildren) => {
  const ooClient = useOOClient()
  return <ApolloProvider client={ooClient}>{children}</ApolloProvider>
}
